export class RackSuggestionRequest {
    storeConsumptionId:number;
    reportingCases?: number;

    constructor(storeConsumptionId:number,reportingCases?: number) {
        this.storeConsumptionId= storeConsumptionId;
        this.reportingCases= reportingCases;
    }
}